import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { useStore } from 'hooks/useStore';

import { Content } from '../Content';

const Mobile = () => {
  const {
    app: { i18n },
    filter: { extraParams },
  } = useStore();

  const actions = {
    cancel: {
      onClick: extraParams.resetPaymentParams,
      text: i18n.common.reset,
    },
  };

  return (
    <MobileScreen hasBackButton actions={actions} title={i18n.payment.label}>
      <Content />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
